import type React from "react";

interface AppHeaderProps {
  title: string;
  children?: React.ReactNode;
}

export function AppHeader({ title, children }: Readonly<AppHeaderProps>) {
  return (
    <div className="flex items-center justify-between px-3 pt-3 pb-2">
      <div>
        <h2 className="text-base font-medium text-gray-900 select-none">
          {title}
        </h2>
      </div>
      {children && <div className="flex items-center gap-1">{children}</div>}
    </div>
  );
}
